import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import Join from "./Join";
import org from "./images/ORG.png";
import ryl from "./images/RYL.png";
import tt from "./images/TT.png";
import organizer from "./images/organizer.png";

function Home() {
  const navigate = useNavigate();
  const joinRef = useRef(null);

  return (
    <div>
      {/* <div className="upcoming">
        <img className="upcoming-event" src={tars}></img>
      </div> */}
      <h1>What we do</h1>
      <p className="description">
        Renters Action Network (RAN) is a grassroots mass organization dedicated
        to organizing and fighting for tenants. We aim to build revolutonary
        tenant unions in Portland Oregon to give renters the tools to fight for
        their housing. We believe that safe, guaranteed housing is the people's
        right, not a privilege and can only be achieved by organizing the
        masses.
      </p>
      <div className="actions-container">
        {/* <div className='projects'>Our </div> */}
        <div className="action-item-list">
          <button onClick={() => (joinRef.current as any).scrollIntoView()}>
            <img src={organizer} alt="Become an Organizer" />
            <h3>Become an Organizer</h3>
          </button>
          <button onClick={() => navigate("/org-my-building")}>
            <img src={org} alt="Organize Your Building" />
            <h3>Organize Your Building</h3>
          </button>
          <button
            onClick={() => window.open("https://tenantstribune.noblogs.org/")}
          >
            <img src={tt} alt="Read the Tenants Tribune" />
            <h3>Read the Tenants Tribune</h3>
          </button>
          <button
            onClick={() => {
              window.open("https://rateyourlandlordpdx.com/");
            }}
          >
            <img src={ryl} alt="RateYourLandlordPDX.com" />
            <h3>Rate Your Landlord</h3>
          </button>
          {/* <button
            className="item dto"
            onClick={() => navigate("/tenant-organizing")}
          >
            <img src={tars} alt="Tenant Organizing" />
            <p>
              Organize <strong>working-class Tenant Unions</strong> around the
              city!
            </p>
          </button>
          <button
            className="item rate"
            onClick={() => {
              window.open("https://rateyourlandlordpdx.com/");
            }}
          >
            <img src={ryl} alt="RateYourLandlordPDX.com" />
            <p>
              Figure out who owns your building, review them, and get connected
              with your neighbors
            </p>
          </button>
          <button
            className="item prop-item"
            onClick={() => window.open("https://tenantstribune.noblogs.org/")}
          >
            <img src={tribune} alt="Read the Tenants Tribune" />
            <p>
              Read the Tenants Tribune, our newspaper focused on the struggle
              for housing in Portland and internationally!
            </p>
          </button> */}
        </div>
      </div>
      <div className="goals">
        {/* <h2>Our Goals</h2>
      <ul>
        <li>Build Tenant Power</li>
        <li>Lower the Rent</li>
        <li>Prevent Evictions</li>
        <li>Protect Renters Rights</li>
        <li>Housing for all</li>
      </ul> */}
      </div>
      <div ref={joinRef}>
        <Join></Join>
      </div>
    </div>
  );
}

export default Home;
